document.addEventListener('DOMContentLoaded', function () {
  const $loginForm = $('.js-auth__form')

  if ($loginForm.length) {
    initAdminLoginForm($loginForm)
  }
})

const initAdminLoginForm = function ($loginForm) {
  const $errorBox = $('.js-auth__error')

  $loginForm.on('submit', function (e) {
    e.preventDefault()
    const data = $loginForm.find(':input').serializeArray()

    $.post('/admin/login', data)
      .done(res => {
        $errorBox.html('')
        $errorBox.hide()

        if (res.success) {
          window.location.href = res.redirect_url
          return
        }

        if (res.error.code === 'no code') {
          $('.js-auth__email').hide()
          $('.js-auth__password').hide()
          $('.js-auth__otp').show()
        }

        $errorBox.html(res.error.message)
        $errorBox.show()
      })
      .always(() => {
        $('.js-auth__submit').prop('disabled', false)
      })
  })
}
